/* Skullette FALL CLEARANCE — shared formatters + cart-add helpers. Loaded first (defer); exposes window.SFC
 * consumed by skullette-fall-clearance-access.js and the rotation/shelf/quick-view/sticky-bar modules.
 * Pattern cloned from Skullette Spooky Deal core (skullette-spooky-deal-core.js). Fall Clearance has no shared
 * clock — access/phase logic (personal 60-min timer, gate, season end) lives in skullette-fall-clearance-access.js. */
(function () {
  var root = document.querySelector('[data-sfc]');
  if (!root) return;

  function money(n) { return '$' + Number(n).toFixed(2); }
  function pct(price, compare) { return compare > price ? Math.round(100 - (100 * price) / compare) : 0; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function mmss(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return pad(Math.floor(s / 60)) + ':' + pad(s % 60); }
  function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // Skullette titles carry a lining note (" - Black Interior - ") — drop it so cards read "Othello" Leather Handbag
  function cleanTitle(t) { return String(t).replace(/\s*-?\s*FALL\s*CLEARANCE\s*DEAL\s*$/i, '').replace(/\s*-\s*Black Interior\s*-\s*/i, ' ').replace(/\s+/g, ' ').trim(); }
  // Pill labels: drop option parts shared by every variant, tidy the rest ("Premium Vegan Leather" → "Vegan").
  function variantLabels(names, short) {
    var parts = names.map(function (n) { return String(n).split(/\s*\/\s*/); });
    return parts.map(function (ps) {
      var keep = ps.filter(function (x, i) { return parts.length < 2 || !parts.every(function (o) { return o[i] === x; }); });
      return (keep.length ? keep : ps).map(function (x) {
        x = x.replace(/\s*\(.*?\)\s*/g, '').replace(/^Premium\s+/i, '').replace(/top[- ]grain/i, 'Top-Grain');
        return short ? x.replace(/\s+Leather$/i, '') : x;
      }).join(' · ');
    });
  }
  // Vegan-family option FIRST (preselected everywhere — ops uses "Premium Vegan Leather" / "Veganique Leather" /
  // "Premium Faux Leather" across different product lines, all the affordable non-genuine-leather material),
  // Top-Grain (genuine leather) second, any other variant kept after.
  function orderVariants(vs) {
    var vegan = vs.filter(function (v) { return /vegan|faux/i.test(v.title || v.name || ''); });
    var grain = vs.filter(function (v) { return /top[- ]grain/i.test(v.title || v.name || '') && vegan.indexOf(v) < 0; });
    var rest = vs.filter(function (v) { return vegan.indexOf(v) < 0 && grain.indexOf(v) < 0; });
    return vegan.concat(grain, rest);
  }

  // ---- cart: Horizon module (window.SFCCart, opens drawer) → plain AJAX fallback ----
  function addToCart(variantId) {
    var items = [{ id: Number(variantId), quantity: 1 }];
    if (window.SFCCart) return window.SFCCart.add({ items: items });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || 'Could not add to cart');
        return null;
      });
    });
  }

  function flyToCart(src, fromEl) {
    if (!src || !fromEl || !fromEl.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = [].slice.call(document.querySelectorAll('.header-actions__cart-icon, #cart-bubble')).filter(function (el) { return el.offsetParent !== null; })[0];
    if (!target) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var size = 64;
    var el = document.createElement('div');
    el.className = 'sfc-fly';
    el.style.backgroundImage = 'url("' + src + '")';
    el.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    el.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(el);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px) scale(.7)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.4 }
    ], { duration: 650, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' }).onfinish = function () { el.remove(); };
  }

  // Button feedback shared by Lightning + shelf + quick-view adds. Fires 'sfc:added' with the cart so the sticky bar
  // repaints without a GET. Returns a Promise that settles once the final label has been shown and restored.
  function runAdd(btn, variantId, src) {
    if (btn.disabled) return Promise.resolve();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Claimed ✓';
    btn.classList.add('is-added');
    flyToCart(src, btn);
    return new Promise(function (settle) {
      var done = function (txt, ms) {
        btn.textContent = txt;
        setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-added'); settle(); }, ms);
      };
      addToCart(variantId).then(function (cart) {
        done('Claimed ✓', 1200);
        root.dispatchEvent(new CustomEvent('sfc:added', { detail: { cart: cart } }));
      }).catch(function (e) {
        btn.classList.remove('is-added');
        done(/sold out|not available|quantity|stock/i.test(e.message) ? 'Sold out' : 'Try again', 2200);
      });
    });
  }

  window.SFC = {
    root: root, money: money, pct: pct, mmss: mmss, img: img, esc: esc,
    cleanTitle: cleanTitle, variantLabels: variantLabels, orderVariants: orderVariants, runAdd: runAdd
  };
})();
